import React from 'react'
import { IconButton, IconButtonProps } from '@mui/material'
import { styled } from '@mui/material/styles'
import AddIcon from '@mui/icons-material/Add'

export interface FabProps extends Omit<IconButtonProps, 'color' | 'size'> {
  size?: 'md' | 'lg'
  label?: string
}

const Root = styled(IconButton, {
  shouldForwardProp: (p) => p !== 'fabSize',
})<{ fabSize: 'md' | 'lg' }>(({ fabSize }) => ({
  width: fabSize === 'lg' ? 56 : 44,
  height: fabSize === 'lg' ? 56 : 44,
  backgroundColor: 'var(--ds-inverse)',
  color: 'var(--ds-inverse-ink)',
  borderRadius: 'var(--ds-radius-pill)',
  boxShadow: 'none',
  transition: `transform var(--ds-duration-fast) var(--ds-ease), box-shadow var(--ds-duration-normal) var(--ds-ease)`,
  '& .MuiSvgIcon-root': {
    fontSize: fabSize === 'lg' ? 24 : 22,
  },
  '&:hover': {
    backgroundColor: 'var(--ds-inverse)',
    boxShadow: 'var(--ds-shadow-soft)',
    transform: 'translateY(-1px)',
  },
  '&:active': { transform: 'scale(0.96)' },
}))

/** Primary create action — circular + */
export const Fab = React.forwardRef<HTMLButtonElement, FabProps>(function Fab(
  { size = 'lg', label = 'Create', children, ...rest },
  ref,
) {
  return (
    <Root ref={ref} fabSize={size} aria-label={label} {...rest}>
      {children ?? <AddIcon />}
    </Root>
  )
})
